import React from 'react';

import routes from 'app/routes';

export default function NoIndex() {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <h2>No talent score yet</h2>

      <div className="mb-4">
        Start by invitation team members to take the assessment.
        Their talent scores will appear here once completed.
      </div>
      <a href={routes.managers.members.add} className="btn btn-primary">Invite Team Members</a>
    </div>
  );
}
